import { render, staticRenderFns } from "./IprelayHeader.vue?vue&type=template&id=6cf2d087"
import script from "./IprelayHeader.vue?vue&type=script&lang=js"
export * from "./IprelayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports